<zest-title-step [mainTitle]="'Select an option to pay Rs. ' + downPayment"></zest-title-step>
<div class="card">
  <div class="content">
    <div class="row" *ngIf="errorMsg">
      <div class="col s12 m12 l12 center red-text error-msg" [textContent]="errorMsg"></div>
    </div>
    <div class="row web-view hide-on-small-only">
      <div class="col l8 m11">
        <div class="col s12 l3 m4 padding0 left-menu border-right">
          <ul class="text-right">
            <li (click)="selectTab(1)" [hidden]="savedCards.length==0" [ngClass]="activeTab==1 ? 'active': ''">Saved Cards</li>
            <li (click)="selectTab(2)" [ngClass]="activeTab==2 ? 'active': ''">Debit/Credit Cards</li>
            <li (click)="selectTab(3)" [ngClass]="activeTab==3 ? 'active': ''">Net Banking</li>
          </ul>
        </div>
        <div [hidden]="activeTab !=1 || savedCards.length==0" class="col s12 l9 m8 _saved-cards">
          <div class=" tab saved-cards" *ngFor="let card  of savedCards; let j = index">
            <form id="saved_card_form-{{j}}">
              <div class="col l11 s12 m12 offset-s0 offset-l1">
                <div>
                  <div class="row">
                    <div class="col l12 s12 m12 border card-detail">
                      <input class="with-gap" name="group1" type="radio" (click)="selectedSavedCard(j)" [(ngModel)]="selectedCard" [value]="j"
                        [checked]="selectedCard==j" id="card{{j}}" />
                      <label for="card{{j}}">
                      <div class="col l9 s6 m9 mid-div">
                        <p class="left">
                          <img class="left" [hidden]="card.cardBrand !='MASTERCARD'" src="../assets/images/juspay/mastercard.png" />
                          <img class="left" [hidden]="card.cardBrand !='VISA'" src="../assets/images/juspay/visa.png" />
                        </p>
                        <p class="">
                          <span class="text-muted">Card Number</span><br/>
                          <span class="cardnumber card_number_div" [textContent]="card.cardNumber"></span>
                        </p>
                      </div>
                      <div class="col l3 s3 m3 padding0">
                        <div class="security_code_div "></div>
                      </div>
                    </label>
                      <div class="error-box right">
                        <span *ngIf="errorMapSavedCard.cardCvv.invalid && selectedCard==j">Invalid CVV</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <input type="hidden" class="redirect" value="true">
                  <input type="hidden" class="order_id" [value]="orderId" />
                  <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                  <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                  <input type="hidden" *ngIf="card.cardIsin" class="card_isin" [value]="card.cardIsin">
                  <input type="hidden" class="card_token" [value]="card.cardToken" />
                  <div class="col l8">
                    <input type="submit" class="hide _submit-btn" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col l11 s12 m12 offset-l1 offset-s0">
            <div class="row">
              <div class="col l8">
                <button type="button" (click)="submitSavedCardForm($event, selectedCard, 'web')" class="btn waves-effect elec-button">Pay Securely</button>
              </div>
              <div class="col l4 cancel"> <a (click)="gotToPrevStep()">Cancel</a></div>
              <div class="col l12">
                <p class="text-center secure-msg"><img src="../assets/images/juspay/lock_m.png">Your card details are secured via 128 bit excryption by version</p>
              </div>
            </div>
          </div>
          <div class="col l12 m12 protection">
            <div>
              <div class="inline-block">
                <img src="../../../assets/images/juspay/trust-icon.png" class="shield-img" />
              </div>
              <div class="inline-block">
                <div class="disclaimer1">100% payment protection</div>
                <div class="disclaimer2">Instant refund | No questions asked</div>
              </div>
            </div>
          </div>
        </div>
        <div [hidden]="activeTab !=2 " class="col s12 l9  m8 ">
          <div class="row tab debit-card">
            <form id="payment_form_debit_card">
              <div class="col l10 s12 m12 offset-s0 offset-s0 offset-l1">
                <div>
                  <p class="left"> Card Number</p>
                  <p class="right images">
                    <img src="../assets/images/juspay/rupay.png" />
                    <img class="border" src="../assets/images/juspay/visa.png" />
                    <img class="border" src="../assets/images/juspay/maestro.png" />
                    <img class="border" src="../assets/images/juspay/mastercard.png" />
                  </p>
                </div>
                <div>
                  <div class="card_number_div" tabindex="1"></div>
                  <div class="error-box">
                    <span *ngIf="errorMap.cardNumber.invalid">Invalid Card Number</span>
                  </div>
                </div>
                <div>
                  <p>Name on Card</p>
                  <div class="name_on_card_div" tabindex="2"></div>
                  <div class="error-box">
                    <span *ngIf="errorMap.cardName.invalid">Invalid Card Holder Name</span>
                  </div>
                </div>
                <div class="row">
                  <div>
                    <div class="col l2 s2 m2">
                      <p>Month</p>
                      <div class="card_exp_month_div" tabindex="3"></div>
                      <div class="error-box">
                        <span *ngIf="errorMap.cardMonth.invalid">Card Month</span>
                      </div>
                    </div>
                    <div class="col l2 s2 m2">
                      <p>Year</p>
                      <div class="card_exp_year_div" tabindex="4"></div>
                      <div class="error-box">
                        <span *ngIf="errorMap.cardYear.invalid">Card Year</span>
                      </div>
                    </div>
                    <div class="col l3 s3 m3 offset-l1 offset-s1">
                      <p>CVV</p>
                      <div class="security_code_div" tabindex="5"></div>
                      <div class="error-box">
                        <span *ngIf="errorMap.cardCvv.invalid">Invalid Card CVV</span>
                      </div>
                    </div>
                    <div class="col l1 m1">
                      <img class="cvv-icon" src="../assets/images/juspay/cvv.png">
                    </div>
                  </div>
                </div>
                <div class="row save-checkbox">
                  <div class="col l12 m12">
                    <input type="checkbox" class="filled-in juspay_locker_save" id="filled-in-box" checked="checked" />
                    <label for="filled-in-box">Save this card for faster payments</label>
                  </div>
                </div>
                <div class="row">
                  <input type="hidden" class="redirect" value="true">
                  <input type="hidden" class="order_id" [value]="orderId" />
                  <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                  <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                  <div class="col l8">
                    <button type="submit" (click)="submitform($event)" class="btn waves-effect elec-button">Pay Securely</button>
                    <input type="submit" class="hide _submit-btn" />
                  </div>
                  <div class="col l4 cancel"> <a (click)="gotToPrevStep()">Cancel</a></div>
                  <div class="col l12">
                    <p class="text-center secure-msg"><img src="../assets/images/juspay/lock_m.png">Your card details are secured via 128 bit excryption by
                      version</p>
                  </div>
                  <div class="col l12 m12 protection">
                    <div>
                      <div class="inline-block">
                        <img src="../../../assets/images/juspay/trust-icon.png" class="shield-img" />
                      </div>
                      <div class="inline-block">
                        <div class="disclaimer1">100% payment protection</div>
                        <div class="disclaimer2">Instant refund | No Questions asked</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div [hidden]="activeTab !=3" class="col s12 l9 m8 ">
          <form #f="ngForm" id="netbanking-form-web">
            <div class="row tab netbanking">
              <div class="col l10 s12 offset-s0 offset-l1">
                <p class="text"><b>SELECT FROM POPULAR BANKS</b></p>
                <div class="row">
                  <div class="bank-img-container" *ngFor="let recommendedBank of recommendedBanks">
                    <div class="col l2 s6 m2 padding0 bank">
                      <label [for]="'bank_' + recommendedBank.paymentMethod">
                      <input ngDefaultControl [(ngModel)]="selectedBank" [value]="recommendedBank.paymentMethod" [ngModelOptions]="{standalone: true}" class="with-gap _input hide" name="bank" type="radio" [id]="'bank_' + recommendedBank.paymentMethod"/>
                      <img class="bank-image" [src]="'../assets/images/bank-logo/' + recommendedBank.image">
                      <p class="bank-label" [textContent]="recommendedBank.label"></p>
                    </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col m12 s12 l12 ">
                    <p>OR SELECT OTHER BANK</p>
                  </div>
                  <div class="input-field col l6 s12">
                    <select ngDefaultControl [(ngModel)]="selectedBank" [ngModelOptions]="{standalone: true}" class="browser-default border payment_method ">
                    <option value="" disabled selected>Select Bank</option>
                    <option *ngFor="let bank  of availableBanks; let i = index" [value]="bank.paymentMethod" [textContent]="bank.name"></option>
                  </select>
                  </div>
                </div>
                <div class="row">
                  <div>
                    <input type="hidden" class="redirect" value="true">
                    <input type="hidden" class="order_id" [value]="orderId" />
                    <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                    <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                    <div class="col l8">
                      <button type="submit" (click)="submitNBForm($event);" [disabled]="selectedBank==''" class="btn waves-effect elec-button">Pay Securely</button>
                      <input type="submit" class="hide _submit-btn" /> </div>
                    <div class="col l4 cancel"> <a (click)="gotToPrevStep()">Cancel</a></div>
                    <div class="col l12 m12 protection">
                      <div>
                        <div class="inline-block">
                          <img src="../../../assets/images/juspay/trust-icon.png" class="shield-img" />
                        </div>
                        <div class="inline-block">
                          <div class="disclaimer1">100% payment protection</div>
                          <div class="disclaimer2">Instant refund | No Questions asked</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row mobile-view hide-on-med-and-up">
      <div class="col s12 zest-collapsible">
        <ul class="collapsible" data-collapsible="accordion">
          <li>
            <div class="collapsible-header " (click)="selectTab(1)"><b>Debit/Credit Card</b> </div>
            <div class="collapsible-body white">
              <ul class="collapsible borderless _mobile-view" data-collapsible="accordion">
                <li class="{{savedCards.length==0 ? 'active' : '' }}">
                  <div class="collapsible-header row borderless {{savedCards.length==0 ? 'active' : '' }}"><b><a  (click)="addNewCardFn(2)"  class=" _add-new-card"><img src="../assets/images/juspay/add_card.png" /> Add New Card</a></b>                    </div>
                  <div class="collapsible-body borderless">
                    <form id="debit-card-m">
                      <div class="debit-card row">
                        <div class="row">
                          <div class="col s12 mobile-card-row">
                            <p class="left"> Card Number</p>
                            <p class="right images">
                              <img src="../assets/images/juspay/rupay.png" />
                              <img class="border" src="../assets/images/juspay/visa.png" />
                              <img class="border" src="../assets/images/juspay/maestro.png" />
                              <img class="border" src="../assets/images/juspay/mastercard.png" />
                            </p>
                            <div class="card_number_div"></div>
                            <div class="error-box">
                              <span *ngIf="errorMap.cardNumber.invalid">Invalid Card Number</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col s12  mobile-card-row">
                            <span>Name on Card</span>
                            <div class="name_on_card_div"></div>
                            <div class="error-box">
                              <span *ngIf="errorMap.cardName.invalid">Invalid Card Holder Name</span>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="">
                            <div class="col s3 mobile-card-row">
                              <p>Month</p>
                              <div class="card_exp_month_div"></div>
                              <div class="error-box">
                                <span *ngIf="errorMap.cardMonth.invalid">Card Month</span>
                              </div>
                            </div>
                            <div class="col s3 mobile-card-row">
                              <p>Year</p>
                              <div class="card_exp_year_div"></div>
                              <div class="error-box">
                                <span *ngIf="errorMap.cardYear.invalid"> Card Year</span>
                              </div>
                            </div>
                            <div class="col s3 mobile-card-row">
                              <p>CVV</p>
                              <div class="security_code_div "></div>
                              <div class="error-box">
                                <span *ngIf="errorMap.cardCvv.invalid">Invalid Card CVV</span>
                              </div>
                            </div>
                            <div class="col s1 mobile-card-row">
                              <img class="cvv-icon" src="../assets/images/juspay/cvv.png">
                            </div>
                          </div>
                        </div>
                        <div class="row save-checkbox">
                          <br/><br/>
                          <div class="col l12 m12">
                            <input type="checkbox" class="filled-in juspay_locker_save" id="filled-in-box-m" checked="checked" />
                            <label for="filled-in-box-m">Save this card for faster payments</label>
                          </div>
                        </div>
                        <br/><br/>
                        <div class="row">
                          <input type="hidden" class="redirect" value="true">
                          <input type="hidden" class="order_id" [value]="orderId" />
                          <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                          <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                          <div class="col s12">
                            <button type="submit" (click)="submitform($event)" class="btn waves-effect elec-button">Pay Securely</button>
                            <input type="submit" class="hide _submit-btn" />
                          </div>
                          <div class="col s12 margin-2t">
                            <p class="text-center secure-msg"><img src="../assets/images/juspay/lock_m.png">Your card details are secured via 128 bit excryption
                              by version</p>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </li>
              </ul>
              <div [hidden]="savedCards.length==0">
                <div class="row saved-card" *ngFor="let card  of savedCards; let i = index">
                  <div class="col s12 ">
                    <form id="saved_card_form-m-{{i}}">
                      <div class="row">
                        <div>
                          <input class="with-gap" name="group1" type="radio" (click)="selectedSavedCard(i)" [(ngModel)]="selectedCard" [value]="i"
                            [checked]="selectedCard==i" id="card{{i}}" />
                          <label for="card{{i}}">
                        <div class="col s9">
                          <img class="left" [hidden]="card.cardBrand !='MASTERCARD'" src="../assets/images/juspay/mastercard.png" />
                          <img class="left" [hidden]="card.cardBrand !='VISA'" src="../assets/images/juspay/visa.png" />
                          <p class="cardnumber text-center" [textContent]="card.cardNumber"></p>
                        </div>
                        <div class="col s3">
                          <div class="security_code_div"></div>
                        </div>
                        <div  class="error-box right">
                          <span *ngIf="errorMapSavedCard.cardCvv.invalid && selectedCard==i">Invalid Card CVV</span>
                        </div>
                      </label>
                        </div>
                        <div class="row button-row">
                          <div class="col s12">
                            <input type="hidden" class="redirect" value="true">
                            <input type="hidden" class="order_id" [value]="orderId" />
                            <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                            <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                            <input type="hidden" *ngIf="card.cardIsin" class="card_isin" [value]="card.cardIsin">
                            <input type="hidden" class="card_token" [value]="card.cardToken" />
                            <div class="col s12">
                              <input type="submit" class="hide _submit-btn" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col s12">
                    <button type="submit" (click)="submitSavedCardForm($event, selectedCard, 'mob')" class="btn waves-effect elec-button">Pay Securely</button>
                  </div>
                  <div class="col s12">
                    <p class="text-center secure-msg"><img src="../assets/images/juspay/lock_m.png">Your card details are secured via 128 bit excryption by
                      version</p>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li (click)="selectTab(3)">
            <div class="collapsible-header"><b>Net Banking</b></div>
            <div class="collapsible-body">
              <form id="netbanking-m">
                <div class="row netbanking">
                  <div *ngFor="let recommendedBank of recommendedBanks">
                    <div class="col s2 bank">
                      <label [for]="'bank_' + recommendedBank.paymentMethod">
                      <input ngDefaultControl [(ngModel)]="selectedBank" [value]="recommendedBank.paymentMethod" [ngModelOptions]="{standalone: true}" name="bank" type="radio" [id]="'bank_' + recommendedBank.paymentMethod"/>
                      <img class="bank-image" [src]="'../assets/images/bank-logo/' + recommendedBank.image">
                      <p class="bank-label" [textContent]="recommendedBank.label"></p>
                    </label>
                    </div>
                  </div>
                  <div class=" col s12">
                    <select ngDefaultControl [(ngModel)]="selectedBank" [ngModelOptions]="{standalone: true}" class="browser-default border payment_method ">
                      <option value="" disabled selected>Select Bank</option>
                      <option *ngFor="let bank  of availableBanks; let i = index" [value]="bank.paymentMethod" >{{bank.name}}</option>
                    </select>
                    <br/>
                    <br/>
                  </div>
                  <br/>
                  <div class="col s12 text-center">
                    <div>
                      <input type="hidden" class="redirect" value="true">
                      <input type="hidden" class="order_id" [value]="orderId" />
                      <input type="hidden" class="merchant_id" value="ZESTMONEY" />
                      <input type="hidden" class="payment_method_type" [value]="paymentMethod">
                      <div class="col s12">
                        <button type="submit" (click)="submitNBForm($event)" [disabled]="selectedBank==''" class="btn  elec-button">Pay Securely</button>
                        <input type="submit" class="hide _submit-btn" />
                      </div>
                      <div class="col s12">
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </li>
        </ul>
        <div class="col s12 cancel text-center"> <a (click)="gotToPrevStep()">Cancel</a></div>
      </div>
    </div>
    <div class="clr"></div>
    <div class="center">
      <hr class="trust">
    </div>
    <div class="col s12 center">
      <div class="trusted-by">Trusted By</div>
      <img src="../../assets/images/trust-logo.png" />
    </div>
  </div>
</div>